<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <Header :showGoBack="true" />

    <main
      class="scrollable container"
      :style="{paddingTop: '10px'}"
    >
      <h2 :style="{marginBottom: '20px'}">Privacy policy</h2>
      <ul>
        <li
          :key="item.id"
          v-for="item in privacy"
          :style="{marginBottom: '30px'}"
        >
          <h4 :style="{marginBottom: '10px', color: 'var(--main-dark)'}">
            {{ item.title }}
          </h4>

          <p :class="'t16'">
            {{ item.text }}
          </p>
        </li>
      </ul>
    </main>
  </div>
</template>

<script setup>
import {Header} from '@/components';

import {useOpacity} from '@/hooks';
const opacity = useOpacity();

const privacy = [
  {
    id: 1,
    title: '1. Terms',
    text: 'By accessing this website, you are agreeing to be bound by these website Terms and Conditions of Use, applicable laws and regulations and their compliance. If you disagree with any of the stated terms and conditions, you are prohibited from using or accessing this site. The materials contained in this site are secured by relevant copyright and trademark law.',
  },
  {
    id: 2,
    title: '2. Use Licence',
    text: 'Permission is allowed to temporarily download one duplicate of the materials (data or programming) on Company is site for individual and non-business use only. This is just a permit of license and not an exchange of title',
  },
  {
    id: 3,
    title: '3. Disclaimer',
    text: 'The materials on Company is site are given "as is". Company makes no guarantees, communicated or suggested, and thus renounces and nullifies every single other warranties, including without impediment, inferred guarantees or states of merchantability, fitness for a specific reason, or non-encroachment of licensed property or other infringement of rights.',
  },
];
</script>
